import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts';

function PieChart({ data, colors, options }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const pieOptions = {
      colors,
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: { enabled: false },
      showInLegend: false,
      ...options,
    };

    Highcharts.chart(containerRef?.current, {
      chart: {
        type: 'pie',
        backgroundColor: null,
        margin: 0,
        height: containerRef?.current?.offsetWidth,
      },
      title: { text: '' },
      tooltip: { pointFormat: '' },
      credits: { enabled: false },
      plotOptions: {
        pie: pieOptions,
        series: {
          states: {
            hover: { enabled: true },
          },
        },
      },
      series: [
        {
          data,
        },
      ],
    });
  }, [data, colors, options]);

  return <div ref={containerRef} />;
}

PieChart.propTypes = {
  data: PropTypes.array.isRequired,
  colors: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
};

export default PieChart;
